<template name="u-select">
  <div class="sxxzq">
    <van-field v-bind="$attrs" @click="show = true" v-model="name" :placeholder="placeholder" :border="true"/>
    <van-popup v-model="show" position="bottom">
      <van-picker show-toolbar :columns="dataList" @confirm="onConfirm" @cancel="show = false" value-key="title" />
    </van-popup>
    <span class="dx"></span>
  </div>
</template>

<script>
/**
 * input 选择框
 * 不要直接引用父组件传过来的值，可以把接收到的父组件的值赋值给一个新的参数
 * 1.加入页面传入url,和请求参数。
 * 2.看是否加入选择后得回调。
 * @description
 */
import { getAction } from '@/api/manage'
export default {
  name: 'u-select',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    list: {
      type: Array,
      default() {
        return []
      },
    },
    ifNetData: {
      type: Boolean,
      default: true,
    },
    defValue: {
      type: String,
      default: '',
    },
    dictCode: String,
  },
  created() {
    if (this.ifNetData) {
      this.getData()
    }
  },
  data() {
    return {
      show: false,
      dataList: this.list,
      name: '',
      myValue: this.value,
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.dataList = this.list
      },
    },
    defValue: {
      immediate: true,
      handler() {
        this.name = this.defValue
      },
    },
    myValue(newVal) {
      console.log(newVal);
      this.$emit('input', newVal)
    },
  },
  methods: {
    onConfirm(value, indexArr) {
      this.show = false
      try {
        if (value instanceof Array) {
          let name = ''
          let arr = [...this.columns]
          value.map((val, i) => {
            name += name == '' ? val : '-' + val
            let index = indexArr[i]
            let obj = arr[index]
            if (obj.children && obj.children.length > 0) {
              arr = obj.children
            } else {
              this.myValue = obj.code
            }
          })
          this.name = name
        } else {
          this.name = value.title
          this.myValue = value.code||value.value;
        }
      } catch (error) {}
    },
    /**
     * 公司获取字典值得url
     */
    getData() {
      let url = `/sys/dict/getDictItems/${this.dictCode}`
      getAction(url).then((res) => {
        if (res.success) {
          let list = res.result
          this.dataList = list
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.sxxzq .dx::after {
    // position: absolute;
    // box-sizing: border-box;
    // content: ' ';
    // pointer-events: none;
    // right: 16px;
    // bottom: 0;
    // left: 16px;
    // border-bottom: 1px solid #ebedf0;
    // -webkit-transform: scaleY(.5);
    // transform: scaleY(.5);
}
</style>
